import { useSelector } from "react-redux";
import "./ToolUseRequest.scss";
import { chatSelectors } from "../../store/chatReducer";
import { toolPluginSelectors } from "../../../tools/store/toolPluginReducer";
import ToolUseRequest from "./ToolUseRequest";

const ReplyToolUses = ({ onApprove, onReject }) => {
  const replyToolUses = useSelector(chatSelectors.getReplyToolUses);
  const toolPluginList = useSelector(toolPluginSelectors.getList);

  if (!replyToolUses) {
    return null;
  }

  return replyToolUses.map((toolUse) => {
    const plugin = toolPluginList.find((plugin) => {
      const toolsJson = JSON.parse(plugin.mcpToolsJson);
      return toolsJson.find((tool) => tool.name === toolUse.toolName);
    });
    const pluginName = plugin ? plugin.name : "";
    return (
      <ToolUseRequest
        key={toolUse.toolUseId}
        toolUse={toolUse}
        pluginName={pluginName}
        isExpanded={true}
        allowActions={true}
      />
    );
  });
};

export default ReplyToolUses;
